/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomFromJSON, StreemApiRoomToJSON, StreemApiRoomParticipantFromJSON, StreemApiRoomParticipantToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiEventsRoomParticipantCreatedFromJSON(json) {
    return StreemApiEventsRoomParticipantCreatedFromJSONTyped(json, false);
}
export function StreemApiEventsRoomParticipantCreatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : StreemApiUserFromJSON(json['user']),
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'participant': !exists(json, 'participant') ? undefined : StreemApiRoomParticipantFromJSON(json['participant']),
    };
}
export function StreemApiEventsRoomParticipantCreatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': StreemApiUserToJSON(value.user),
        'room': StreemApiRoomToJSON(value.room),
        'participant': StreemApiRoomParticipantToJSON(value.participant),
    };
}
//# sourceMappingURL=StreemApiEventsRoomParticipantCreated.js.map